import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router';
import { Capacitor } from '@capacitor/core';
import { useAuthStore } from '@/stores/authStore';

// Lazy so the marketing subtree (hero, vignettes, WaitlistForm → firebase
// functions) is a separate chunk instead of eager weight in the root bundle —
// native builds and authenticated users redirect to /app and never fetch it.
const LandingPage = lazy(() => import('@/pages/LandingPage'));

/**
 * Decider for `/`. Native (Capacitor) builds and authenticated users go
 * straight to the app; everyone else (anonymous web visitors) sees the public
 * marketing page.
 */
export function MarketingRoot() {
  const authMode = useAuthStore((s) => s.authMode);
  if (Capacitor.isNativePlatform() || authMode === 'authenticated') {
    return <Navigate to="/app" replace />;
  }
  return (
    <Suspense
      fallback={<div className="flex min-h-dvh items-center justify-center bg-canvas text-t3" />}
    >
      <LandingPage />
    </Suspense>
  );
}

export default MarketingRoot;
